"use strict";exports.useCheckEmptyString=(r,t)=>{if(""===r)throw new Error(t)};
